import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type AuditLogEntryResponse } from '../api/generated';
import { fetchAuditLog } from '../services/patientDetailsService';
import { useAppDispatch } from '../store/hooks';
import { showError } from '../store/errorDialog/errorDialogSlice';

interface UseAuditLogResult {
  data: AuditLogEntryResponse[];
  isLoading: boolean;
  error: boolean;
}

export function useAuditLog(
  locationId: string | undefined,
  patientId: string | undefined
): UseAuditLogResult {
  const [data, setData] = useState<AuditLogEntryResponse[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (!locationId || !patientId) return;
    let cancelled = false;
    setIsLoading(true);
    setError(false);
    void fetchAuditLog(locationId, patientId)
      .then((result) => {
        if (!cancelled) {
          setData(result);
          setIsLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError(true);
          setIsLoading(false);
          dispatch(showError({ message: t('fetch-error') }));
        }
      });
    return () => { cancelled = true; };
  }, [locationId, patientId, dispatch, t]);

  return { data, isLoading, error };
}
